import style from "./App.module.css";
import { useState, useEffect, useRef } from "react";
import jsonData from "./personality_data.json";
function App() {
  // const unique = ["순발력: ", "근력: ", "지력: ", "집중력: "];
  const [selectData, setSelectData] = useState("");
  const [personality, setPersonality] = useState("");
  const [bloodData, setBloodData] = useState(1);
  const [speed, setSpeed] = useState("");
  const [power, setPower] = useState("");
  const [smart, setSmart] = useState("");
  const [select, setSelect] = useState("");
  const [isdark, setIsdark] = useState("");
  const [training, setTraining] = useState("");
  // const [isOpen, setIsOpen] = useState(false);
  const refTk = useRef();
  const state = {
    speed: "순발력",
    power: "근력",
    smart: "지력",
    select: "집중력",
  };

  const dark_mode = () => {
    window.localStorage.setItem("isdark", !isdark);
    setIsdark(!isdark);
    if (!isdark) {
      document.documentElement.setAttribute("color-theme", "dark");
    } else {
      document.documentElement.setAttribute("color-theme", "light");
    }
  };

  const get_select_data = () => {
    if (selectData.personality === personality) return selectData;
    for (let i in jsonData) {
      if (jsonData[i].personality === personality) {
        return jsonData[i];
      }
    }
  };
  const min_num_of_elements = (start_n, end_n = undefined) => {
    if (end_n === undefined) end_n = start_n;
    if (start_n > end_n) [start_n, end_n] = [end_n, start_n];

    const nums = [3, 5, 9];

    const memo = {};

    const findMinimumCombinations = (n, depth) => {
      if (n === 0) return [0, 0, 0];

      if (memo[n] && memo[n][depth]) return memo[n][depth];

      let minCombinations = Array(nums.length).fill(Infinity);
      let minSum = Infinity;

      for (let i = depth; i < nums.length; i++) {
        if (n - nums[i] >= 0) {
          const nextCombinations = [...findMinimumCombinations(n - nums[i], i)];
          nextCombinations[i]++;

          const sum = nextCombinations.reduce((a, b) => a + b, 0);

          if (sum < minSum) {
            minSum = sum;
            minCombinations = nextCombinations;
          }
        }
      }

      if (!memo[n]) memo[n] = {};
      memo[n][depth] = minCombinations;
      return minCombinations;
    };

    let minResult = Infinity;
    let min_combinations;

    for (let n = start_n; n <= end_n; n++) {
      const result = findMinimumCombinations(n, 0);
      const sumResult = result.reduce((a, b) => a + b, 0);
      if (sumResult < minResult) {
        minResult = sumResult;
        min_combinations = result;
      }
    }
    console.log(min_combinations);
    return [minResult, min_combinations.reverse()];
  };

  const training_calculation = (speed, power, select, smart, data) => {
    const rankings = [
      // 순 근 집 지
      ["speed", Number(speed), data.speed],
      ["power", Number(power), data.power],
      ["select", Number(select), data.concentration],
      ["smart", Number(smart), data.smart],
    ];
    let result1s = [];
    let mindata = data.limit;
    rankings.sort((a, b) => a[2] - b[2]);
    if (rankings.reduce((acc, val) => acc + val[2], 0) === 4) {
      let max_second = 0;
      rankings.sort((a, b) => b[1] - a[1]);
      for (let i in rankings) {
        max_second = rankings.reduce(
          (acc, cur) => Math.max(acc, cur[1]),
          Number.NEGATIVE_INFINITY
        );
        let min_elements1;
        if (max_second < mindata) max_second = mindata - rankings[i][1];
        else max_second -= rankings[i][1];
        if (data.up) {
          min_elements1 = min_num_of_elements(max_second, 100);
        } else if (i == 0) {
          min_elements1 = min_num_of_elements(max_second, 100);
          mindata =
            min_elements1[1][0] * 9 +
            min_elements1[1][1] * 5 +
            min_elements1[1][2] * 3 +
            rankings[i][1];
        } else min_elements1 = min_num_of_elements(max_second);
        let result1 = min_elements1[1];
        result1.unshift(rankings[i][0]);
        result1s.push(result1);
      }
    } else {
      if (rankings[1][2] !== 0) {
        result1s.push([rankings[0][0], 0, 0, 0]);
        if (mindata < rankings[0][1]) mindata = rankings[0][1];
        for (let i = 1; i < rankings.length; i++) {
          if (rankings[i][2] === 0) result1s.push([rankings[0][0], 0, 0, 0]);
          else {
            let min_elements1;
            mindata -= rankings[i][1];
            if (i === 3 || data.up) {
              if (mindata < 3)
                min_elements1 = min_num_of_elements(
                  mindata + (3 - mindata),
                  500
                );
              else min_elements1 = min_num_of_elements(mindata + 1, 500);
            } else if (rankings[i][2] === rankings[i - 1][2]) {
              min_elements1 = min_num_of_elements(mindata);
            } else {
              if (mindata < 3)
                min_elements1 = min_num_of_elements(mindata + (3 - mindata));
              else min_elements1 = min_num_of_elements(mindata + 1);
            }
            mindata =
              min_elements1[1][0] * 9 +
              min_elements1[1][1] * 5 +
              min_elements1[1][2] * 3 +
              rankings[i][1];
            let result1 = min_elements1[1];
            result1.unshift(rankings[i][0]);
            result1s.push(result1);
          }
        }
      } else {
        for (let i = 1; i < rankings.length; i++)
          result1s.push([rankings[0][0], 0, 0, 0]);
        let min_elements1;
        let max_second = rankings.reduce(
          (acc, cur) => Math.max(acc, cur[1]),
          Number.NEGATIVE_INFINITY
        );
        if (max_second < mindata) max_second = mindata - rankings[3][1];
        else max_second -= rankings[3][1];
        min_elements1 = min_num_of_elements(max_second + 1, 100);
        let result1 = min_elements1[1];
        result1.unshift(rankings[3][0]);
        result1s.push(result1);
      }
    }
    return result1s;
  };
  useEffect(() => {
    if (
      personality === "" ||
      personality === "성격" ||
      speed === "" ||
      power === "" ||
      select === "" ||
      smart === ""
    )
      return setTraining("");

    refTk.current += refTk.current;
    const data = get_select_data();
    setSelectData(data);
    let trainingdata = training_calculation(speed, power, select, smart, data);
    for (let i in Object.keys(state)) {
      for (let j = 0; j < trainingdata.length; j++) {
        if (trainingdata[j][0] === Object.keys(state)[i]) {
          trainingdata[j][0] = state[trainingdata[j][0]];
          trainingdata.push(trainingdata[j]);
        }
      }
    }
    trainingdata = trainingdata.slice(4);
    setTraining(trainingdata);
  }, [personality, speed, power, select, smart]);

  useEffect(() => {
    const localdark = window.localStorage.getItem("isdark");
    setIsdark(localdark === "true");
    if (localdark === "true") {
      document.documentElement.setAttribute("color-theme", "dark");
    } else {
      document.documentElement.setAttribute("color-theme", "light");
    }
  }, []);
  return (
    <div className={style.main}>
      <img
        src={`./images/${isdark ? "night" : "sun"}.png`}
        className={isdark ? style.night : style.sun}
        height={25}
        width={25}
        onClick={dark_mode}
      />
      <div className={style.head_cube}>
        <div className={style.head_box}>
          <div>
            <div className={style.unique_title}>노력치</div>
            <div className={style.content_box}>
              <div>순발력</div>
              <input
                type="number"
                value={speed}
                onClick={(e) => setSpeed("")}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length < 4) setSpeed(e.target.value);
                }}
              />
            </div>
            <div className={style.content_box}>
              <div>근력</div>
              <input
                type="number"
                value={power}
                onClick={(e) => setPower("")}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length < 4) setPower(e.target.value);
                }}
              />
            </div>
            <div className={style.content_box}>
              <div>집중력</div>
              <input
                type="number"
                value={select}
                onClick={(e) => setSelect("")}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length < 4) setSelect(e.target.value);
                }}
              />
            </div>
            <div className={style.content_box}>
              <div>지력</div>
              <input
                type="number"
                value={smart}
                onClick={(e) => setSmart("")}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length < 4) setSmart(e.target.value);
                }}
              />
            </div>
          </div>
          <select
            className={style.select}
            onChange={(e) => setPersonality(e.target.value)}
          >
            <option value={"default"}>성격</option>
            {jsonData.map((v, i) => (
              <option key={v.personality}>{v.personality}</option>
            ))}
          </select>
          <select
            className={style.select}
            onClick={(e) => setBloodData(e.target.value)}
            onChange={(e) => setBloodData(e.target.value)}
          >
            {[...Array(5)].map((_, index) => (
              <option key={index}>
                {index + 1}
                {index > 3 ? "세대 이상" : "세대"}
              </option>
            ))}
          </select>
        </div>
        <div className={style.explanation}>
          {selectData.explanation === undefined
            ? "선택된 성격에 대한 설명이 나와요."
            : selectData.explanation}
        </div>
      </div>
      {personality === "" ||
      personality === "성격" ||
      speed === "" ||
      power === "" ||
      select === "" ||
      smart === "" ? (
        <div className={style.warning}>
          {(personality === "" || personality === "성격") && (
            <div>선택된 성격이 없어요.</div>
          )}
          {speed === "" && <div>순발력에 값을 넣어주세요.</div>}
          {power === "" && <div>근력에 값을 넣어주세요.</div>}
          {select === "" && <div>집중력에 값을 넣어주세요.</div>}
          {smart === "" && <div>지력에 값을 넣어주세요.</div>}
        </div>
      ) : (
        <>
          {selectData && training && (
            <>
              {selectData.personality}까지 남은 훈련은...
              <div className={style.container}>
                {training.map((v, i) => (
                  <TrainingBlock
                    key={`training_${i}`}
                    title={v[0]}
                    stat={[
                      [9, v[1]],
                      [5, v[2]],
                      [3, v[3]],
                    ]}
                  />
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default App;

const TrainingBlock = ({ title, stat }) => {
  return (
    <div className={style.training_block}>
      <div className={style.training_title}>{title}</div>
      <div className={style.stat_box}>
        {console.log(stat)}
        {stat.map(
          (s, i) =>
            s[1] > 0 && (
              <div className={style.stat_row} key={`stat_${i}`}>
                +{s[0]}을 {s[1]}번
              </div>
            )
        )}
      </div>
    </div>
  );
};
